<template>
    <div class="buttons-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Buttons</h3>
                </div>
                
                <button type="button" class="btn btn-primary mb-1 me-1">Primary</button>
                <button type="button" class="btn btn-secondary mb-1 me-1">Secondary</button>
                <button type="button" class="btn btn-success mb-1 me-1">Success</button>
                <button type="button" class="btn btn-danger mb-1 me-1">Danger</button>
                <button type="button" class="btn btn-warning mb-1 me-1">Warning</button>
                <button type="button" class="btn btn-info mb-1 me-1">Info</button>
                <button type="button" class="btn btn-light mb-1 me-1">Light</button>
                <button type="button" class="btn btn-dark mb-1 me-1">Dark</button>
                <button type="button" class="btn btn-link mb-1 me-1">Link</button>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Button Tags</h3>
                </div>

                <a class="btn btn-primary" href="#" role="button">Link</a>
                <button class="btn btn-primary mb-1 me-1" type="submit">Button</button>
                <input class="btn btn-primary mb-1 me-1" type="button" value="Input">
                <input class="btn btn-primary mb-1 me-1" type="submit" value="Submit">
                <input class="btn btn-primary mb-1 me-1" type="reset" value="Reset">
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Outline Buttons</h3>
                </div>
                
                <a class="btn btn-primary" href="#" role="button">Link</a>
                <button class="btn btn-primary mb-1 me-1" type="submit">Button</button>
                <input class="btn btn-primary mb-1 me-1" type="button" value="Input">
                <input class="btn btn-primary mb-1 me-1" type="submit" value="Submit">
                <input class="btn btn-primary mb-1 me-1" type="reset" value="Reset">
            </div>

            <div class="card-box-style bg-color-f8faff">
                <div class="others-title">
                    <h3>Outline Buttons</h3>
                </div>
                
                <button type="button" class="btn btn-outline-primary mb-1 me-1">Primary</button>
                <button type="button" class="btn btn-outline-secondary mb-1 me-1">Secondary</button>
                <button type="button" class="btn btn-outline-success mb-1 me-1">Success</button>
                <button type="button" class="btn btn-outline-danger mb-1 me-1">Danger</button>
                <button type="button" class="btn btn-outline-warning mb-1 me-1">Warning</button>
                <button type="button" class="btn btn-outline-info mb-1 me-1">Info</button>
                <button type="button" class="btn btn-outline-light mb-1 me-1">Light</button>
                <button type="button" class="btn btn-outline-dark mb-1 me-1">Dark</button>
            </div>

            <div class="card-box-style bg-color-f8faff">
                <div class="others-title">
                    <h3>Disabled state</h3>
                </div>
                
                <button type="button" class="btn btn-primary mb-1 me-1" disabled>Primary button</button>
                <button type="button" class="btn btn-secondary mb-1 me-1" disabled>Button</button>
                <button type="button" class="btn btn-outline-primary mb-1 me-1" disabled>Primary button</button>
                <button type="button" class="btn btn-outline-secondary mb-1 me-1" disabled>Button</button>
            </div>

            <div class="card-box-style bg-color-f8faff">
                <div class="others-title">
                    <h3>Block buttons</h3>
                </div>
                
                <div class="d-grid gap-2">
                    <button class="btn btn-primary mb-1" type="button">Button</button>
                    <button class="btn btn-primary mb-1" type="button">Button</button>
                </div>
            </div>

            <div class="card-box-style bg-color-f8faff">
                <div class="others-title">
                    <h3>Block buttons center</h3>
                </div>
                
                <div class="d-grid gap-2">
                    <div class="d-grid gap-2 col-6 mx-auto">
                        <button class="btn btn-primary mb-1" type="button">Button</button>
                        <button class="btn btn-primary mb-1" type="button">Button</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ButtonsContent'
}
</script>